import { render } from "./ProductPriceList.vue?vue&type=template&id=676dd578&scoped=true"
import script from "./ProductPriceList.vue?vue&type=script&lang=js"
export * from "./ProductPriceList.vue?vue&type=script&lang=js"

import "./ProductPriceList.vue?vue&type=style&index=0&id=676dd578&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676dd578"]])

export default __exports__